<querybuilder [RBACORG]="RBACORG" [PERMISSION]="PERMISSION" [queryBuilderEvent]="queryBuilderEvent"></querybuilder>
